import { render, staticRenderFns } from "./PartnershipsGrid.vue?vue&type=template&id=8aa84408&scoped=true"
import script from "./PartnershipsGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnershipsGrid.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa84408",
  null
  
)

export default component.exports